import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { activeRecord } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';
import { userWithQualificationSelector } from './selectors/user';

/**
 * Query users with provided conditions, either with qualification name or user property search (i.e. names, email).
 * @param limit number of results to be returned for the query.
 * @param offset result set start offset.
 * @param qualificationQuery qualification name query.
 * @param userQuery user properties search query.
 * @returns query result with user (by qualification) and search_user.
 */
const useQueryUser = (
  limit: number,
  offset: number,
  onError: (error: ApolloError) => void,
  qualificationId?: string,
  userQuery?: string
) => {
  const qualificationQueryCondition = {
    group_membership: {
      group: {
        qualifications: {
          qualification_id: {
            _eq: qualificationId ?? '',
          },
        },
      },
    },
  };

  return useTypedQuery(
    {
      user: [
        {
          where: { ...qualificationQueryCondition, ...activeRecord },
          limit,
          offset,
        },
        userWithQualificationSelector,
      ],
      search_user: [
        {
          args: { search: userQuery ?? '' },
          limit,
          offset,
        },
        userWithQualificationSelector,
      ],
      search_user_aggregate: [
        {
          args: { search: userQuery ?? '' },
        },
        { aggregate: { count: [{}, true] } },
      ],
      user_aggregate: [
        {
          where: { ...qualificationQueryCondition, ...activeRecord },
        },
        { aggregate: { count: [{}, true] } },
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onError,
      },
    }
  );
};

export default useQueryUser;
